import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppComponent } from './app.component';
import { NxModule } from '@nrwl/angular';
import { RouterModule, Routes } from '@angular/router';
import { AngularFireModule } from '@angular/fire';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { CustomMaterialModule } from '@sk/custom-material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  AngularFirestoreModule
} from '@angular/fire/firestore';
import { SignOutGuard } from './_shared/guards/signOut.guard';
import { AuthorizationGuard } from './_shared/guards/authorization.guard';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { LogbookDialogModule } from './components/dialogs/logbook-dialog/logbook-dialog.module';
import { NotifyDialogModule } from './components/dialogs/notify-dialog/notify-dialog.module';
import { ContactsDialogModule } from './components/dialogs/contacts-dialog/contacts-dialog.module';
import { CompleteOrderDialogModule } from './components/dialogs/complete-order-dialog/complete-order-dialog.module';
import { WorkloadDialogModule } from './components/dialogs/workload-dialog/workload-dialog.module';
import { httpInterceptorProviders } from './_shared/http-interceptors';
import { OrganizationUserResolver } from './_shared/resolver/organization-user.resolver';
import { ServiceWorkerModule } from '@angular/service-worker';

import { registerLocaleData } from '@angular/common';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';
import { UiPwaSpinnerModule } from './_shared/services/ui-spinner/ui-pwa-spinner.module';
import { TimeFormatPwaModule } from './_shared/pipes/timeFormatPwa/timeFormatPwa.module';
import { StorageModule } from '@ngx-pwa/local-storage';
import { OngoingOrderGuard } from './_shared/guards/ongoing-order.guard';
import { LanguageGuard } from './_shared/guards/language.guard';
import { AngularFirePerformanceModule } from '@angular/fire/performance';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { PwaStateModule } from './+state/state.module';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es-US';
import localeNl from '@angular/common/locales/nl';

// registerLocaleData(environment.locale);
console.log('env.language ' + environment.language);

if (environment.language === 'en-US') {
  registerLocaleData(localeEn, environment.language);
  moment.locale(environment.language);
}

if (environment.language === 'es-US') {
  registerLocaleData(localeEs, environment.language);
  moment.locale(environment.language);
}

if (environment.language === 'nl-NL') {
  registerLocaleData(localeNl, environment.language);
  moment.locale(environment.language);
}

export const appRoutes: Routes = [
  {
    path: 'login',
    canActivate: [LanguageGuard],
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'signout',
    canActivate: [SignOutGuard],
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'auth',
    canActivate: [AuthorizationGuard],
    loadChildren: () => import('./_authenticated/authenticated.module').then(m => m.AuthenticatedModule)
  },
  { path: '',
    canActivate: [LanguageGuard],
    pathMatch: 'full',
    redirectTo: '/auth/schedule' },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/auth'
  }
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NxModule.forRoot(),
    CustomMaterialModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule.enablePersistence(),
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFirePerformanceModule,
    AngularFireAnalyticsModule,
    RouterModule.forRoot(appRoutes, { initialNavigation: 'enabled', relativeLinkResolution: 'legacy' }),
    HttpClientModule,
    ContactsDialogModule,
    CompleteOrderDialogModule,
    NotifyDialogModule,
    LogbookDialogModule,
    WorkloadDialogModule,
    UiPwaSpinnerModule,
    TimeFormatPwaModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    }),
    StorageModule.forRoot({
      IDBNoWrap: true
    }),
    StoreModule.forRoot(
      {},
      {
        metaReducers: !environment.production ? [] : [],
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true
        }
      }
    ),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    PwaStateModule
  ],
  providers: [
    AuthorizationGuard,
    OngoingOrderGuard,
    LanguageGuard,
    SignOutGuard,
    httpInterceptorProviders,
    { provide: LOCALE_ID, useValue: environment.language },
    { provide: MAT_DATE_LOCALE, useValue: environment.language },
    OrganizationUserResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
